import React, { useState, useEffect, useContext, memo } from "react";
import { Col, Form, FormGroup, Label } from "reactstrap";
import * as Constants from '../../../utils/Constants';
import { formDataContext } from "../LoginPage";
import { Button, TextField, MessageAlert } from "../../../components/Components";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import TextFieldPassword from "../../../components/TextFieldPassword/TextFieldPassword";
import "./ResetPassword.css";

const ResetPassword = () => {

    const {
        username, setUsername,
        email, setEmail,
        code, setCode,
        newPassword, setNewPassword,
        confirmPassword, setConfirmPassword,
        isInValidUsername, setIsInValidUsername,
        isInValidEmail, setIsInValidEmail,
        isInvalidCode, setIsInValidCode,
        isInValidNewPassword, setIsInValidNewPassword,
        isInValidConfirmPassword, setIsInValidConfirmPassword,
        lang,
        HandleChangeLanguage,
        SendEmail,
        ValidateVerificationCode,
        ChangePassword,
        ResendVerificationCode,
        resetStep,
        BackLoginPage,
        mode
    } = useContext(formDataContext);

    const { t } = useTranslation();

    const SetNewPassword = (password) => {
        if (validatePassword(password.slice(-1))) {
            setNewPassword(password);
            setIsInValidNewPassword(false);
        }
        else {
            MessageAlert.warning({
                title: t('Warning'),
                message: t('PasswordNotValid'),
            });
        }
    };

    const ConfirmPassword = (password) => {
        if (validatePassword(password.slice(-1))) {
            setConfirmPassword(password);
            setIsInValidConfirmPassword(false);
        }
        else {
            MessageAlert.warning({
                title: t('Warning'),
                message: t('PasswordNotValid'),
            });
        }
    }

    const validatePassword = (password) => {
        const validPassword =
        /^(?=.*[a-z])/.test(password)
        || /^(?=.*[A-Z])/.test(password)
        || /^(?=.*[0-9])/.test(password)
        || /^(?=.*[()\-+|\\<>,.?=!@#\$%\^&\*])/.test(password);

        if (!validPassword && password != ''){
            return false;
        }
        else{
            return true;
        }
    }

    return (
        <>
            <div className="Reset-container">
                <div style={{ textAlign: "end" }}>
                    <ToggleButtonGroup
                        size="small"
                        value={lang}
                        exclusive
                        onChange={HandleChangeLanguage}
                    >
                        <ToggleButton
                            value="th"
                            style={{
                                color: lang === "th" ? "#FFFFFF" : null,
                                backgroundColor: lang === "th" ? "#1C74D4" : null
                            }}
                        >
                            TH
                        </ToggleButton>
                        <ToggleButton
                            value="en"
                            style={{
                                color: lang === "en" ? "#FFFFFF" : null,
                                backgroundColor: lang === "en" ? "#1C74D4" : null
                            }}
                        >
                            EN
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className="Reset-detail">
                    {
                        resetStep === "1" &&
                        <div>
                            <div className="Reset-title">
                                <Label style={{ fontWeight: 'bold', width: '100%' }}>
                                    {t('ResetPassword')}
                                </Label>
                                <Label>{t('EnterRecoverEmail')}</Label>
                            </div>
                            <Label>{t('Username')}</Label>
                            <div
                                style={{ height: '60px', textAlign: 'end' }}
                            >
                                <TextField
                                    placeholder={t('EnterUsername')}
                                    required={isInValidUsername}
                                    requiredText={t('PleaseEnterUsername')}
                                    value={username}
                                    onChange={(e) => {
                                        setUsername(e.target.value);
                                        setIsInValidUsername(false);
                                    }}
                                />
                            </div>
                            <Label>{t('Email')}</Label>
                            <div
                                style={{ height: '60px', textAlign: 'end' }}
                            >
                                <TextField
                                    placeholder={t('EnterEmail')}
                                    required={isInValidEmail}
                                    requiredText={t('PleaseEnterEmail')}
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setIsInValidEmail(false);
                                    }}
                                />
                            </div>
                            <div style={{ textAlign: 'end' }}>
                                <Button
                                    title={t('Back')}
                                    onClick={BackLoginPage}
                                    style={{ width: "100px", marginTop: "20px", marginRight: "20px" }}
                                />
                                <Button
                                    title={t('Next')}
                                    onClick={SendEmail}
                                    style={{ width: "100px", marginTop: "20px" }}
                                />
                            </div>
                        </div>
                    }
                    {
                        resetStep === "2" &&
                        <div>
                            <div className="Reset-title">
                                <Label style={{ fontWeight: 'bold', width: '100%' }}>
                                    {mode == Constants.MODE.RESET ? t('ResetPassword') : t('OTPVerification')}
                                </Label>
                                <div>{t('VerificationCodeSent')}</div>
                                <Label>{email}</Label>
                            </div>
                            <Label>{t('VerificationCode')}</Label>
                            <div
                                style={{ height: '60px', textAlign: 'end' }}
                            >
                                <TextField
                                    placeholder={t('EnterVerificationCode')}
                                    required={isInvalidCode}
                                    requiredText={t('PleaseEnterVerificationCode')}
                                    value={code}
                                    onChange={(e) => {
                                        setCode(e.target.value);
                                        setIsInValidCode(false);
                                    }}
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
                                    <Label
                                        style={{ cursor: 'pointer', color: '#1C74D4', fontSize: '14px' }}
                                        onClick={ResendVerificationCode}
                                    >
                                        {t('ResendOtpPassword')}
                                    </Label>
                                </div>
                            </div>
                            <div style={{ textAlign: 'end' }}>
                                <Button
                                    title={t('Next')}
                                    onClick={ValidateVerificationCode}
                                    style={{ width: "100px", marginTop: "20px" }}
                                />
                            </div>
                        </div>
                    }
                    {
                        resetStep === "3" &&
                        <div>
                            <div className="Reset-title">
                                <Label style={{ fontWeight: 'bold', width: '100%' }}>
                                    {t('ResetPassword')}
                                </Label>
                            </div>
                            <Label>{t('NewPassword')}</Label>
                            <div
                                style={{ height: '60px', textAlign: 'end' }}
                            >
                                <TextFieldPassword
                                    placeholder={t('EnterNewPassword')}
                                    required={isInValidNewPassword}
                                    requiredText={t('PleaseEnterNewPassword')}
                                    value={newPassword}
                                    onChange={(e) => {
                                        SetNewPassword(e.target.value);
                                    }}
                                />
                            </div>
                            <Label>{t('ConfirmPassword')}</Label>
                            <div
                                style={{ height: '60px', textAlign: 'end' }}
                            >
                                <TextFieldPassword
                                    placeholder={t('EnterConfirmPassword')}
                                    required={isInValidConfirmPassword}
                                    requiredText={t('PleaseEnterConfirmPassword')}
                                    value={confirmPassword}
                                    onChange={(e) => {
                                        ConfirmPassword(e.target.value);
                                    }}
                                />
                                <div style={{ fontSize: '0.75rem', color: 'black', marginTop: '4px' }}>
                                    {t('TextStrongPass')}
                                </div>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <Button
                                    title={t('Submit')}
                                    onClick={ChangePassword}
                                    style={{ width: "200px", marginTop: "20px" }}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default ResetPassword;